import { selectAccountAttributeElement } from 'affiny-core/redux/selectors/accountSelectors';
import { select } from 'redux-saga/effects';

export function* checkHasCompletedProfile() {
  return yield select(selectAccountAttributeElement, 'hasCompletedProfile');
}
